import { differenceInMilliseconds } from 'date-fns'
import { Component } from 'react'
import { TFunction, withTranslation } from 'react-i18next'

import DatePicker from '@/utilities/client-components/components/DatePicker'

import withSpacing from './WithSpacing'

interface InputDateProps {
  document?: object
  id?: string
  isRequired?: boolean
  label?: string
  max?: string
  min?: string
  placeholder?: string
  registerInputCallback(...args: unknown[]): unknown
  t: TFunction
}

// TODO Hookify, that's a loaded request due to how all of AC is built
// TODO Make AC just be a form...
class InputDate extends Component<InputDateProps> {
  static displayName = 'InputDate'

  constructor(props: any) {
    super(props)

    this.state = {
      value: null,
      error: '',
      selectedMomentDate: null
    }

    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    const { registerInputCallback } = this.props
    registerInputCallback(this)
  }

  value() {
    // @ts-expect-error
    return this.state.value instanceof Date ? this.state.value.toISOString() : ''
  }

  id() {
    return this.props.id
  }

  handleChange(value: any) {
    this.setState({ value, error: '' })
  }

  validate() {
    const { isRequired, min, max, t } = this.props
    // @ts-expect-error
    const { value } = this.state

    const isValidDate = value instanceof Date || value == null
    const isValidIfRequired = !!((isRequired && value instanceof Date) || !isRequired)
    let isAfterMin = true
    if (min && value !== null) {
      isAfterMin = differenceInMilliseconds(new Date(min), value) < 0
    }
    let isBeforeMax = true
    if (max && value !== null) {
      isBeforeMax = differenceInMilliseconds(new Date(max), value) > 0
    }
    const isValidOverall = isValidDate && isValidIfRequired && isAfterMin && isBeforeMax

    if (!isValidIfRequired) {
      this.setState({
        error: t('client:required')
      })
    } else if (value instanceof Date && !isAfterMin) {
      this.setState({
        error: t('client:InputDate.invalidMin')
      })
    } else if (value instanceof Date && !isBeforeMax) {
      this.setState({
        error: t('client:InputDate.invalidMax')
      })
    } else if (!isValidDate) {
      this.setState({
        error: t('client:InputDate.invalidFormat')
      })
    }

    return isValidOverall
  }

  render() {
    const { isRequired, min, max, label } = this.props
    // @ts-expect-error
    const { value, error } = this.state
    // Min/Max should be an ISO string per the API requirements
    const minAsDate = min ? new Date(min) : undefined
    const maxAsDate = max ? new Date(max) : undefined

    return (
      <DatePicker
        isRequired={isRequired}
        label={label}
        value={value}
        minDate={minAsDate}
        maxDate={maxAsDate}
        onChange={this.handleChange}
        onCalendarClose={this.handleChange}
        error={error}
      />
    )
  }
}

export default withSpacing(withTranslation('client')(InputDate))
export { InputDate }
